export function capitalize(s: string): string {
  return s
    .split("-")
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join("-");
}
